// ClientDetail/Components/Appointments/Appointments.jsx
import React from 'react';
import Classes from './Appointments.module.css';
import RecordTable from './RecordTable/RecordTable';

export default function Appointments({ loading, bookings = [], userId }) {
  return (
    <div className={Classes.hero}>
      <RecordTable loading={loading} bookings={bookings} userId={userId} />
    </div>
  );
}
